// extracted by mini-css-extract-plugin
module.exports = {"planStatus":"ReservationFrameStateLabel_planStatus__UjK7z","full":"ReservationFrameStateLabel_full__s5dBx"};